import React, { useState, useEffect, useLayoutEffect } from 'react';
import './UsernamePrompt.css';
import './SignUpModal.css';
import { faker } from '@faker-js/faker';
import { helpers } from '../services/helpers';
import ColorOptions from './ColorOptions'
import Modal from './Modal';
import { FaPlusCircle } from 'react-icons/fa'
const UsernamePrompt = ({ isOpen, onClose, onSubmit, error, facebookProfileName, setFacebookProfileName, facebookProfileImage }) => {
  const [username, setUsername] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [selectedColor, setSelectedColor] = useState('#e0e0e0');
  const [showAnonymous, setShowAnonymous] = useState(false);

  const colors = [...helpers.colors];

  const generateRandomUsername = () => {
    return `${faker.word.adjective()}_${faker.word.noun()}${faker.number.int({ max: 999 })}`
      .toLowerCase()
      .replace(/\s+/g, '');
  };

  const openAnonymous = () => {
    setShowAnonymous(true)
  }

  useLayoutEffect(() => {
    setTimeout(() => {
      const el = document.querySelector('.modal-content');
      if (el) {
        el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
      }
    }, 200)
  }, [showAnonymous])

  useEffect(() => {
    if (isOpen && initialLoad) {
      setUsername(generateRandomUsername());
      const randomColor = colors[Math.floor(Math.random() * colors.length)].value;
      setSelectedColor(randomColor);
      setInitialLoad(false);
    }
  }, [isOpen, initialLoad]);

  const handleAnonymousSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await onSubmit(username, null, selectedColor);
    setIsSubmitting(false);
  };

  const handleFacebookSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await onSubmit(facebookProfileName, facebookProfileImage, null)
  }

  if (!isOpen) return null;

  return (

    <Modal
      onClose={onClose}
      isOpen={isOpen}
      title="Create Profile"
    >
      <div>
        <div className="gapped-login-options login-options form-group" style={{ marginBottom: '0' }}>
          <div>
            <img src={facebookProfileImage} className="header-logo icon" style={{ borderRadius: '1000px', border: '1px solid #2c3e50' }}></img>
          </div>
          <input
            type="text"
            value={facebookProfileName}
            onChange={(e) => setFacebookProfileName(e.target.value)}
            placeholder="Enter your username"
            minLength={1}
            maxLength={50}
            required
          />
          <button onClick={handleFacebookSubmit} className="login-button facebook" disabled={isSubmitting || !facebookProfileName}>
            Use Facebook Profile
          </button>
        </div>
        <div className="divider">
          <span>or</span>
        </div>
        {!showAnonymous ? (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
            <button
              className="show-replies-button review-detail-toggle"
              style={{ magin: 'auto', padding: '0.5rem' }}
              onClick={openAnonymous}
            >
              <FaPlusCircle className="reply-icon feed-reply" />
              Remain Anonymous
            </button>
          </div>
        ) : (
          <form onSubmit={handleAnonymousSubmit}>
            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
              <ColorOptions
                colors={colors}
                selectedColor={selectedColor}
                setSelectedColor={setSelectedColor}
              />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                minLength={3}
                maxLength={50}
                required
              />
              {error && <div className="error-message">{error}</div>}
            </div>

            <button type="submit" disabled={isSubmitting || !username} className="continue-button">
              {isSubmitting ? 'Saving...' : 'Remain Anonymous'}
            </button>
            <div>
              <span style={{ color: '#666', fontSize: '14px', display: 'inline-block', lineHeight: '1.4', paddingTop: '0.5rem' }}>Surgery Journey will never share your personal information without your permission.</span>
            </div>
          </form>
        )}
      </div>
    </Modal>
  );
};

export default UsernamePrompt; 